/* RESPONSIBLE TEAM: team-app-security */

import type AppService from 'embercom/services/app-service';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';
import { isEmpty, isPresent } from '@ember/utils';
// @ts-ignore
import { copy } from 'ember-copy';
import type IntlService from 'ember-intl/services/intl';
import ENV from 'embercom/config/environment';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { ReactRoute } from 'embercom/lib/react-route';

class AccountSecurityRoute extends IntercomRoute {
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;
  @service declare appService: AppService;

  analytics = {
    section: 'settings',
    place: 'personal.account-security',
  };

  reactEnabled() {
    return this.appService.app.canSeeReactPersonalPreferences;
  }

  beforeModel(transition: Transition) {
    if (!this.reactEnabled()) {
      let app = this.modelFor('apps.app');
      this._notifyConfirmationForQueryParams(transition.to.queryParams, app);
    }
  }

  get titleToken() {
    return this.intl.t('new-settings.submenu.personal.preferences');
  }

  async _notifyConfirmationForQueryParams(
    queryParams: { [key: string]: string | undefined },
    app: $TSFixMe,
  ) {
    let originalQueryParams = copy(queryParams);
    if (isPresent(queryParams) && !isEmpty(queryParams)) {
      if (queryParams['verifiedAdminEmail'] === 'true') {
        await app.currentAdmin.reload();
        this.notificationsService.notifyConfirmation(
          this.intl.t('account.general.email-verified', { email: app.get('currentAdmin.email') }),
          ENV.APP._15000MS,
        );
        delete queryParams['verifiedAdminEmail'];
      } else if (queryParams['verifiedAdminEmail'] === 'false') {
        this.notificationsService.notifyError(
          this.intl.t('account.general.could-not-verified', {
            email: app.get('currentAdmin.email'),
          }),
          ENV.APP._15000MS,
        );
        delete queryParams['verifiedAdminEmail'];
      }
      if (originalQueryParams !== queryParams) {
        this.transitionTo('apps.app.settings.personal.account-security', app, { queryParams });
      }
    }
  }
}

export default ReactRoute(AccountSecurityRoute);
